<template>
  <b-progress :value="left" variant="primary" height="3px"></b-progress>
</template>

<script>
export default {
  props: ['seconds', 'start_date'],
  data() {
    return {
      left: 0,
      per_tick: 0,
    };
  },
  mounted() {
    let start_date = this.start_date
    try {
      start_date = this.start_date.toDate()
    } catch (err) {
      // pass
    }
    let difference = (new Date() - start_date) / 1000
    this.left = 0
    this.per_tick = (100 / this.seconds)

    this.left = difference * this.per_tick
    this.timer = setInterval(() => {
      if (this.left > 100) {
        this.left = 100
        clearInterval(this.timer)
        this.timer = null
      }




      this.left = this.left + this.per_tick
      // this.bars.forEach(bar => (bar.value = 25 + Math.random() * 75))
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
};
</script>

<style scoped>

</style>
